import type { PropsRouteBuilder, QueryMappingBuilder } from './router';
import type { TripPlannerProperties, TripPlannerQueryString } from './model';
import { parseRecipe } from './parseRecipe';

export function buildRouteQuery(
  propsRouteBuilder: PropsRouteBuilder
): ReturnType<QueryMappingBuilder<TripPlannerProperties>['mappedToQuery']> {
  return propsRouteBuilder
    .hasProps<TripPlannerProperties>(() => ({
      initialIngredients: [],
      initialPax: [{ numberOfAdults: 2 }],
    }))
    .mappedToQuery<TripPlannerQueryString>(parseRecipe);
}
